import React from "react";
import PropTypes from "prop-types";
import styles from "./LoyaltyMetrics.module.css";

/**
 * Três cards de métricas do programa de fidelidade.
 * - 👥 Clientes no programa  → metrics.totalCards
 * - 🏆 Recompensas já dadas  → metrics.totalRewardsGiven
 * - ⭐ Quase lá!             → metrics.nearRewardCount
 *
 * Em `loading`, renderiza skeletons no mesmo grid para evitar layout shift
 * quando os dados chegam.
 */

function MetricCard({ icon, label, value, ariaLabel = undefined }) {
  return (
    <article className={styles.card} aria-label={ariaLabel || label}>
      <div className={styles.header}>
        <span className={styles.icon} aria-hidden="true">
          {icon}
        </span>
        <span>{label}</span>
      </div>
      <p className={styles.value}>{value}</p>
    </article>
  );
}

MetricCard.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  ariaLabel: PropTypes.string,
};

function SkeletonCard() {
  return (
    <div className={styles.skeletonCard} aria-hidden="true">
      <div className={`${styles.skeletonLine} ${styles.skeletonLineSm}`} />
      <div className={`${styles.skeletonLine} ${styles.skeletonLineLg}`} />
    </div>
  );
}

export default function LoyaltyMetrics({ metrics = null, loading = false }) {
  if (loading) {
    return (
      <div className={styles.grid} aria-busy="true" aria-label="Carregando métricas">
        <SkeletonCard />
        <SkeletonCard />
        <SkeletonCard />
      </div>
    );
  }

  const totalCards = metrics?.totalCards ?? 0;
  const totalRewardsGiven = metrics?.totalRewardsGiven ?? 0;
  const nearRewardCount = metrics?.nearRewardCount ?? 0;

  return (
    <div className={styles.grid}>
      <MetricCard
        icon="👥"
        label="Clientes no programa"
        value={totalCards}
        ariaLabel={`${totalCards} clientes no programa`}
      />
      <MetricCard
        icon="🏆"
        label="Recompensas já dadas"
        value={totalRewardsGiven}
        ariaLabel={`${totalRewardsGiven} recompensas já dadas`}
      />
      <MetricCard
        icon="⭐"
        label="Quase lá! (falta 1 visita)"
        value={nearRewardCount}
        ariaLabel={`${nearRewardCount} clientes a uma visita do prêmio`}
      />
    </div>
  );
}

LoyaltyMetrics.propTypes = {
  metrics: PropTypes.shape({
    totalCards: PropTypes.number,
    totalRewardsGiven: PropTypes.number,
    nearRewardCount: PropTypes.number,
  }),
  loading: PropTypes.bool,
};
